import styled from 'styled-components';

import { STATES } from '../../data/states';
import { ActiveStateOrUSId } from '../../types';
import NavHeading from './NavHeading';

const SelectContainer = styled.div`
	background-color: #fff;
	border-radius: 4px;
	display: grid;
	align-items: center;
	grid-template-areas: 'select';

	&::after {
		background-color: hsl(210, 58%, 33%);
		clip-path: polygon(100% 0%, 0 0%, 50% 100%);
		content: '';
		grid-area: select;
		height: 0.5em;
		justify-self: end;
		margin-right: 0.5rem;
		width: 0.8em;
	}
`;

const Select = styled.select`
	appearance: none;
	background-color: transparent;
	border: 1px solid #ccc;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	grid-area: select;
	padding: 0.5rem 1rem;
	text-align: center;
	width: 100%;
	z-index: 1;
`;

interface Props {
	area: string;
	activeState: ActiveStateOrUSId;
	setActiveState: (stateId: ActiveStateOrUSId) => void;
}

const StateSelect = ({ area, activeState, setActiveState }: Props) => {
	return (
		<div style={{ gridArea: area }}>
			<NavHeading htmlFor="state-select">Select State</NavHeading>
			<SelectContainer>
				<Select
					id="state-select"
					onChange={e => setActiveState(+e.target.value as ActiveStateOrUSId)}
					value={activeState}
				>
					{STATES.map(state => {
						return (
							<option key={state.id} value={state.id}>
								{state.name}
							</option>
						);
					})}
				</Select>
			</SelectContainer>
		</div>
	);
};

export default StateSelect;
